import { createApp, ref } from 'vue'

const app = createApp({
  setup() {
    const posterNumber = ref('')
    const flyerNumber = ref('')
    const postcardNumber = ref('')
    const Maxcount = [30, 3000, 3000]

    const numberIncrement = (type, increment) => {
      // ポスター
      if (type == 0) {
        if (posterNumber.value.value < Maxcount[type]) {
          posterNumber.value.value = Number(posterNumber.value.value) + increment
        }
      }
      // チラシ
      if (type == 1) {
        if (flyerNumber.value.value < Maxcount[type]) {
          flyerNumber.value.value = Number(flyerNumber.value.value) + increment
        }
      }
      // ハガキ
      if (type == 2) {
        if (postcardNumber.value.value < Maxcount[type]) {
          postcardNumber.value.value = Number(postcardNumber.value.value) + increment
        }
      }
    }
    const numberDecrement = (type, decrement) => {
      // ポスター
      if (type == 0) {
        if (posterNumber.value.value > 0) {
          posterNumber.value.value = Number(posterNumber.value.value) - decrement
        }
      }
      // チラシ
      if (type == 1) {
        if (flyerNumber.value.value > 0) {
          flyerNumber.value.value = Number(flyerNumber.value.value) - decrement
        }
      }
      // ハガキ
      if (type == 2) {
        if (postcardNumber.value.value > 0) {
          postcardNumber.value.value = Number(postcardNumber.value.value) - decrement
        }
      }
    }

    return { posterNumber, flyerNumber, postcardNumber, numberIncrement, numberDecrement }
  }
})
if (document.getElementById('numberControl')) {
  app.mount('#numberControl')
}
